import { render, staticRenderFns } from "./WayInfo.vue?vue&type=template&id=81bad41a&scoped=true"
import script from "./WayInfo.vue?vue&type=script&lang=js"
export * from "./WayInfo.vue?vue&type=script&lang=js"
import style0 from "./WayInfo.vue?vue&type=style&index=0&id=81bad41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bad41a",
  null
  
)

export default component.exports